var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visibleFilters.length ? _c('div', {
    staticClass: "crm-active-filters"
  }, _vm._l(_vm.visibleFilters, function (filter) {
    return _c('button', {
      key: filter.key,
      staticClass: "crm-filter-chip",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('remove', filter.key);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))]), _c('strong', [_vm._v(_vm._s(filter.value))]), _c('i', {
      staticClass: "la la-times"
    })]);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };